import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { Presentation } from './presentation';
import { getCsrfToken } from '../../../libs/csrfToken';
import {
  getSearchCompanyFormOptiosForRecruitment,
  searchRecruitments,
} from '../../../services/companies';
import { useDevice } from '../../../hooks/device';
import type { Props } from './types';
import type { SearchFormOptionsForRecruitments } from '../../../types/companies';
import { getSearchBrandFormOptionsForRecruitment } from '../../../services/brands';
import { OccupationDetailsOccupationId } from '../../../types/recruitments';
import {
  FULL_TIME_WORKING_PERIOD_ID,
  SIDEBAR_PREFERENCE_CONDITION_NAMES,
} from '../recruitmentSearchForm/types';
import type { SalaryChange } from '../recruitmentSearchForm/types';

export const Component: FunctionComponent<Props> = ({
  isBrandPage,
  isCompany,
  company,
  h1Title,
  description,
  shouldChangeUrl,
  cancelIcon,
  fromFixed,
  brandId,
  companyId,
  isPage,
  isStopped,
  noimage,
  hoverIcon,
  hasAnyRecruitments,
  isShowAttentionPeople,
}) => {
  const { isPc, chromeEdg } = useDevice();
  const [loading, setLoading] = useState(false);

  const [isSp, setIsSp] = useState(false);
  const [isShowingStoppedList, setIsShowingStoppedList] = useState(window.location.search.includes('status=stopped'));
  const [targetEmploymentTypes, setTargetEmploymentTypes] = useState<any>([]);
  const [targetOccupations, setTargetOccupations] = useState<any>([]);
  const [targetOccupationDetails, setTargetOccupationDetails] = useState<any>([]);
  const [targetPrefectures, setTargetPrefectures] = useState<any>([]);
  const [targetPrefectureDetails, setTargetPrefectureDetails] = useState<any>([]);
  const [targetPrefectureNames, setTargetPrefectureNames] = useState<any>([]);
  const [targetPreferenceConditions, setTargetPreferenceConditions] = useState<any>([]);
  const [targetWorkingPeriods, setTargetWorkingPeriods] = useState<any>([]);
  const [targetSalary, setTargetSalary] = useState<{ target_salary_type: string; target_salary_min: string; target_salary_max: string }>({
    target_salary_type: '',
    target_salary_min: '',
    target_salary_max: '',
  });
  const [q, setQ] = useState('');
  const [occupationDetailsOccupationIds, setOccupationDetailsOccupationIds] = useState<OccupationDetailsOccupationId[]>([
    { occupation_id: 1, occupation_detail_id: [] },
    { occupation_id: 2, occupation_detail_id: [] },
    { occupation_id: 3, occupation_detail_id: [] },
    { occupation_id: 4, occupation_detail_id: [] },
    { occupation_id: 5, occupation_detail_id: [] },
    { occupation_id: 6, occupation_detail_id: [] },
    { occupation_id: 7, occupation_detail_id: [] },
    { occupation_id: 8, occupation_detail_id: [] },
    { occupation_id: 9, occupation_detail_id: [] },
    { occupation_id: 10, occupation_detail_id: [] },
    { occupation_id: 11, occupation_detail_id: [] },
    { occupation_id: 12, occupation_detail_id: [] },
    { occupation_id: 13, occupation_detail_id: [] },
  ]);
  const [prefectureDetails, setPrefectureDetails] = useState<any>({
    '北海道・東北': [],
    関東: [],
    '北陸・甲信越': [],
    東海: [],
    近畿: [],
    '中国・四国': [],
    '九州・沖縄': [],
  });
  const [spStyle, setSpStyle] = useState({ display: 'none' });
  const [toggleStyle, setToggleStyle] = useState({ left: '-800px' });
  const [toggleListStyle, setToggleListStyle] = useState({ display: 'none' });
  const [popupStyle, setPopupStyle] = useState({ display: 'none' });
  const [modalStyle, setModalStyle] = useState({ opacity: '0', visibility: 'hidden' } as React.CSSProperties);
  const [page, setPage] = useState(1);
  const [h1TitleState, setH1TitleState] = useState('');
  const [targetCompanyIds, setTargetCompanyIds] = useState([
    25, 36, 712217509, 355432255, 1234746844, 1848374300, 502054192, 770303514, 99171353, 98337515, 1175055415,
    1817832221, 1440167213, 1915603328, 282389982, 61388724, 120003821, 371565707, 691923133, 736304449, 1009867474,
    692410368, 1806792134, 389226686, 1578517616, 1904067040, 1036439808, 2000911928, 1757694780, 447724633,
  ]);
  const [releasedRecruitmentIds, setReleasedRecruitmentIds] = useState<number[]>([])
  const [stoppedRecruitmentIds, setStoppedRecruitmentIds] = useState<number[]>([])
  const [hasStoppedRecruitments, setHasStoppedRecruitments] = useState(false)
  const hasFetchedInitialStopped = useRef(false)
  const [searchFormOptionsForRecruitment, setSearchFormOptionsForRecruitment] =
    useState<SearchFormOptionsForRecruitments>({} as SearchFormOptionsForRecruitments);
  const [stoppedSearchFormOptionsForRecruitment, setStoppedSearchFormOptionsForRecruitment] =
    useState<SearchFormOptionsForRecruitments>({} as SearchFormOptionsForRecruitments);

  const handleToggleStoppedList = useCallback(() => {
    const newStatus = !isShowingStoppedList;
    setIsShowingStoppedList(newStatus);
    setPage(1);

    setTargetEmploymentTypes([]);
    setTargetOccupations([]);
    setTargetOccupationDetails([]);
    setTargetPrefectures([]);
    setTargetPrefectureDetails([]);
    setTargetPreferenceConditions([]);
    setTargetWorkingPeriods([]);
    setTargetSalary({ target_salary_type: '', target_salary_min: '', target_salary_max: '' });
    setQ('');
    setOccupationDetailsOccupationIds((prev) => prev.map((o) => ({ ...o, occupation_detail_id: [] })));
    setPrefectureDetails({
      '北海道・東北': [],
      関東: [],
      '北陸・甲信越': [],
      東海: [],
      近畿: [],
      '中国・四国': [],
      '九州・沖縄': [],
    });

    const url = new URL(window.location.href);
    if (newStatus) {
      url.searchParams.set('status', 'stopped');
    } else {
      url.searchParams.delete('status');
    }
    url.searchParams.delete('page');
    window.history.pushState({}, '', url.toString());
  }, [isShowingStoppedList]);

  const fetchRecruitments = useCallback(async (status: 'released' | 'stopped') => {
    const csrfToken = getCsrfToken();
    const response = await searchRecruitments({
      csrfToken,
      data: {
        company_id: company.id,
        brand_id: brandId,
        employment_type: targetEmploymentTypes,
        occupation_id: targetOccupations,
        occupation_detail_id: targetOccupationDetails,
        prefecture_ids: targetPrefectureDetails,
        preference_condition_id: targetPreferenceConditions,
        working_period_id: targetWorkingPeriods,
        salary_type_id: targetSalary.target_salary_type,
        salary_min: targetSalary.target_salary_min,
        salary_max: targetSalary.target_salary_max,
        q,
        status,
      },
    });
    if (status === 'released') {
      setReleasedRecruitmentIds(response.recruitment_ids);
    } else {
      setStoppedRecruitmentIds(response.recruitment_ids);
      if (!hasFetchedInitialStopped.current) {
        setHasStoppedRecruitments(response.recruitment_ids.length > 0);
        hasFetchedInitialStopped.current = true;
      }
    }
  }, [
    company?.id,
    brandId,
    targetEmploymentTypes,
    targetOccupations,
    targetOccupationDetails,
    targetPrefectureDetails,
    targetPreferenceConditions,
    targetWorkingPeriods,
    targetSalary,
    q,
  ]);

  const getSearchBrandFormOptions = useCallback(async () => {
    const [releasedResponse, stoppedResponse] = await Promise.all([
      getSearchBrandFormOptionsForRecruitment(brandId ?? ''),
      getSearchBrandFormOptionsForRecruitment(brandId ?? '', 'stopped'),
    ]);
    setSearchFormOptionsForRecruitment(releasedResponse);
    setStoppedSearchFormOptionsForRecruitment(stoppedResponse);
  }, [brandId]);

  const getSearchCompanyForOptions = useCallback(async () => {
    const [releasedResponse, stoppedResponse] = await Promise.all([
      getSearchCompanyFormOptiosForRecruitment(companyId ?? ''),
      getSearchCompanyFormOptiosForRecruitment(companyId ?? '', 'stopped'),
    ]);
    setSearchFormOptionsForRecruitment(releasedResponse);
    setStoppedSearchFormOptionsForRecruitment(stoppedResponse);
  }, [companyId]);

  useEffect(() => {
    if (isBrandPage) {
      getSearchBrandFormOptions();
      if (company?.id) {
        fetchRecruitments('released');
        fetchRecruitments('stopped');
      }
    } else {
      getSearchCompanyForOptions();
      fetchRecruitments('released');
      fetchRecruitments('stopped');
    }
    if (location.search.includes('employment_type')) {
      setTargetEmploymentTypes([decodeURI(location.search).replace('?employment_type=', '')]);
    }
    handleChangeElements(page);
  }, [isBrandPage, company, getSearchBrandFormOptions, getSearchCompanyForOptions, fetchRecruitments]);

  useEffect(() => {
    if (isBrandPage && stoppedRecruitmentIds.length === 0) {
      setIsShowingStoppedList(false);
    }
  }, [isBrandPage, stoppedRecruitmentIds]);

  const handleChangeElements = (page: number) => {
    const isShouldChangeUrl = shouldChangeUrl !== undefined ? shouldChangeUrl : true;
    const url = `${location.protocol}//${location.host}/companies/${company?.id}/recruitments`;
    const extitle = h1Title;
    const seoTitle = `${h1Title} - READY TO FASHION`;
    const descriptionElement = document.querySelector('meta[name="description"]') as Element;

    if (isBrandPage) {
      if (isShouldChangeUrl && company?.id) {
        history.pushState({}, '', url);
      }
      document.title = seoTitle;
      descriptionElement.setAttribute('content', description);
      setH1TitleState(extitle);
    } else {
      if (page === 1) {
        if (isShouldChangeUrl) {
          history.pushState({}, '', url);
        }
        document.title = `${company.name}の求人・採用情報｜READY TO FASHION`;
        descriptionElement.setAttribute('content', description);
        setH1TitleState(extitle);
      } else {
        if (isShouldChangeUrl) {
          const newUrl = url + `?page=${page}`;
          history.pushState({}, '', newUrl);
        }
        document.title = `${company.name}の求人・採用情報（${page}ページ目）｜READY TO FASHION`;
        descriptionElement.setAttribute('content', `（${page}ページ目）${description}`);
        setH1TitleState(`${extitle}（${page}ページ目）`);
      }
    }
  };

  const handleChange = (name: string, array: any) => {
    if (name === 'target_employment_types') {
      setTargetEmploymentTypes(array.filter(Boolean));
    }
    if (name === 'target_occupations') {
      setTargetOccupations(array.filter(Boolean));
    }
    if (name === 'target_occupation_details') {
      setTargetOccupationDetails(array.filter(Boolean));
    }
    if (name === 'target_prefectures') {
      setTargetPrefectures(array.filter(Boolean));
    }
    if (name === 'target_prefecture_details') {
      setTargetPrefectureDetails(array.filter(Boolean));
    }
    if (name === 'target_preference_conditions') {
      setTargetPreferenceConditions(array.filter(Boolean));
    }
    if (name === 'target_working_periods') {
      setTargetWorkingPeriods(array.filter(Boolean));
    }
  };

  const handleClick = (event: any) => {
    const target = $(event.currentTarget);
    const value = $(target).attr('value') as string;
    const name = $(target).attr('name') as string;
    const current = {
      target_employment_types: targetEmploymentTypes,
      target_occupations: targetOccupations,
      target_occupation_details: targetOccupationDetails,
      target_prefectures: targetPrefectures,
      target_prefecture_details: targetPrefectureDetails,
      target_preference_conditions: targetPreferenceConditions,
      target_working_periods: targetWorkingPeriods,
    }[name];
    if ($.inArray(value.split(',')[0], current) > -1) {
      const valueArray = value.split(',');
      const array = current.filter((i: any) => valueArray.indexOf(i) === -1);
      handleChange(name, array);
    } else {
      const array = current.concat(value.split(','));
      handleChange(
        name,
        array.filter((element: any, index: number) => array.indexOf(element) === index)
      );
    }
  };

  const handleChangeQ = (name: string, value: string) => {
    setQ(value);
  };

  const handleFirstRecruitmentLoad = useCallback(() => {
    setLoading(false);
  }, []);

  const listRef = useRef<HTMLElement>(null);

  const handlePaginateClick = useCallback(
    (newPage: number) => {
      setLoading(true);
      const el = listRef.current;
      const top = el ? el.getBoundingClientRect().top + window.scrollY - 56 : 0;
      window.scrollTo({ top, behavior: 'instant' as ScrollBehavior });
      handleChangeElements(newPage);
      setPage(newPage);

      fetchRecruitments('released');
      fetchRecruitments('stopped');
    },
    [handleChangeElements, fetchRecruitments]
  );

  const handlePopup = useCallback(() => {
    if (popupStyle.display !== 'block') {
      setPopupStyle({ display: 'block' });
    } else {
      setPopupStyle({ display: 'none' });
    }
  }, [popupStyle.display]);

  const handleModal = useCallback(() => {
    if (modalStyle.opacity !== '1') {
      setModalStyle({ opacity: '1', visibility: 'visible' } as React.CSSProperties);
    } else {
      setModalStyle({ opacity: '0', visibility: 'hidden' } as React.CSSProperties);
    }
  }, [modalStyle.opacity]);

  useEffect(() => {
    const isModalOpen = modalStyle.opacity === '1';
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [modalStyle.opacity]);

  const closePopup = useCallback(() => {
    setPopupStyle({ display: 'none' });
  }, []);

  const handleOpenSp = useCallback(() => {
    if (!isSp) {
      setToggleStyle({ left: '0px' });
      setIsSp(true);
      setSpStyle({ display: 'block' });
      $('body').css({ height: '100dvh', overflow: 'hidden' });
    } else {
      setToggleStyle({ left: '-800px' });
      setIsSp(false);
      setSpStyle({ display: 'none' });
      $('body').css({ height: 'auto', overflow: 'unset' });
    }
  }, [isSp]);

  const handleSearch = useCallback(async () => {
    await fetchRecruitments('released');
    await fetchRecruitments('stopped');
  }, [fetchRecruitments]);

  const handleFetchOccupationDetails = useCallback(
    (occupationId: number | string, occupationDetailId: string) => {
      const baseArray = [...occupationDetailsOccupationIds];
      const current = baseArray[Number(occupationId) - 1].occupation_detail_id as any;
      const occupationCurrent = [...targetOccupations];

      if (current.includes(occupationDetailId.split(',')[0])) {
        const valueArray = occupationDetailId.split(',');
        const valueOccupationArray = String(occupationId).split(',');
        const array = current.filter((i: any) => !valueArray.includes(i));
        const occupationArray = occupationCurrent.filter((i) => !valueOccupationArray.includes(i));

        baseArray[Number(occupationId) - 1].occupation_detail_id = array;
        setOccupationDetailsOccupationIds(baseArray);
        setTargetOccupations(occupationArray);
      } else {
        const array = current.concat(occupationDetailId.split(','));
        baseArray[Number(occupationId) - 1].occupation_detail_id = array;

        const newTargetOccupations = [...occupationCurrent];
        if (
          (Number(occupationId) === 1 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 6) ||
          (Number(occupationId) === 2 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 9) ||
          (Number(occupationId) === 3 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 9) ||
          (Number(occupationId) === 4 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 20) ||
          (Number(occupationId) === 5 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 27) ||
          (Number(occupationId) === 6 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 8) ||
          (Number(occupationId) === 7 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 6) ||
          (Number(occupationId) === 8 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 4) ||
          (Number(occupationId) === 9 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 14) ||
          (Number(occupationId) === 10 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 9) ||
          (Number(occupationId) === 11 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 14) ||
          (Number(occupationId) === 12 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 10) ||
          (Number(occupationId) === 13 && baseArray[Number(occupationId) - 1].occupation_detail_id.length === 7)
        ) {
          newTargetOccupations.push(String(occupationId));
        }
        setOccupationDetailsOccupationIds(baseArray);
        setTargetOccupations(newTargetOccupations.filter((element, index, self) => self.indexOf(element) === index));
      }
    },
    [occupationDetailsOccupationIds, targetOccupations]
  );

  const checkAllOccupationDetails = useCallback(
    (occupationId: number | string, checked: boolean, baseArray?: any[]) => {
      if (!baseArray) return;

      const occIndex = Number(occupationId) - 1;
      let newTargetOccs = [...targetOccupations];

      if (checked) {
        // --- 大カテゴリ ON ---
        // occupationDetailsOccupationIds の見た目更新
        baseArray[occIndex].occupation_detail_id = [...baseArray];

        // targetOccupations にこのカテゴリを追加
        if (!newTargetOccs.includes(String(occupationId))) {
          newTargetOccs.push(String(occupationId));
        }
      } else {
        // --- 大カテゴリ OFF ---
        baseArray[occIndex].occupation_detail_id = [];
        newTargetOccs = newTargetOccs.filter((id) => id !== String(occupationId));
      }

      // state更新
      setOccupationDetailsOccupationIds(baseArray);
      setTargetOccupations(newTargetOccs);
    },
    [occupationDetailsOccupationIds, targetOccupationDetails, targetOccupations]
  );

  const handleFetchPrefectureDetails = useCallback(
    (areaName: string, prefectureId: string) => {
      const newPrefectureDetails = { ...prefectureDetails } as any;
      const current = newPrefectureDetails[areaName];
      const currentPrefectureDetails = [...targetPrefectureDetails];

      if (current.includes(prefectureId.split(',')[0])) {
        const valueArray = prefectureId.split(',');
        const nameArray = areaName.split(',');
        const array = current.filter((i: any) => !valueArray.includes(i));
        const prefectureArray = currentPrefectureDetails.filter((i) => !prefectureId.includes(i));
        const targetPrefecturesArray = [...targetPrefectures];

        newPrefectureDetails[areaName] = array;
        setPrefectureDetails(newPrefectureDetails);
        setTargetPrefectureDetails(prefectureArray);
        setTargetPrefectures(targetPrefecturesArray.filter((i) => !nameArray.includes(i)));
      } else {
        const array = current.concat(prefectureId.split(','));
        newPrefectureDetails[areaName] = array;
        setPrefectureDetails(newPrefectureDetails);
        setTargetPrefectures(areaName.split(','));
      }
    },
    [prefectureDetails, targetPrefectureDetails, targetPrefectures]
  );

  const checkAllPrefectureDetails = useCallback(
    (array: any, areaName: string, checked: boolean) => {
      const current = [...targetPrefectureDetails];
      const newPrefectureDetails = { ...prefectureDetails } as any;

      if (checked) {
        const targetArray = current.concat(array);
        newPrefectureDetails[String(areaName)] = array;
        setTargetPrefectureDetails(targetArray.filter((element, index) => targetArray.indexOf(element) === index));
        setPrefectureDetails(newPrefectureDetails);
      } else {
        let updatedTargetPrefectureDetails = [...current];
        const constants = {
          '北海道・東北': ['1', '2', '3', '4', '5', '6', '7'],
          関東: ['8', '9', '10', '11', '12', '13', '14'],
          '北陸・甲信越': ['15', '16', '17', '18', '19', '20'],
          東海: ['21', '22', '23', '24'],
          近畿: ['25', '26', '27', '28', '29', '30'],
          '中国・四国': ['31', '32', '33', '34', '35', '36', '37', '38', '39'],
          '九州・沖縄': ['40', '41', '42', '43', '44', '45', '46', '47'],
        } as any;

        const constantsArray = constants[areaName];
        if (constantsArray) {
          const duplicates = current.filter((item) => constantsArray.includes(item));
          updatedTargetPrefectureDetails = current.filter((item) => !duplicates.includes(item));
        }
        setTargetPrefectureDetails(updatedTargetPrefectureDetails);

        newPrefectureDetails[areaName] = [];
        setPrefectureDetails(newPrefectureDetails);
      }
    },
    [prefectureDetails, targetPrefectureDetails]
  );

  const openList = useCallback((event: any) => {
    const parent = event.target;
    const target = event.target.nextElementSibling;
    $(parent).toggleClass('active');
    $(target).toggleClass('active');
  }, []);

  const dataCategory = {
    companyRecruitmentList: 'companyrecruitmentlist',
    stopCompanyRecruitmentList: 'stopcompanyrecruitmentlist',
    brandContent: 'brandcontent',
    stopBrandContent: 'stopbrandcontent',
  };
  const dataValue = {
    recruitments: 'recruitments',
    recruitmentsScoutTag: 'recruitments_scout_tag',
    recruitmentsEntryTag: 'recruitments_entry_tag',
    recruitmentsNewTag: 'recruitments_new_tag',
    recruitmentsPermanentTag: 'recruitments_permanent_tag',
    recruitmentsActiveTag: 'recruitments_active_tag',
    recruitmentsHiringTag: 'recruitments_hiring_tag',
    recruitmentsAttentionTag: 'recruitments_attention_tag',
    recruitmentsAllTag: 'recruitments_all_tag',
  };
  const dataClickPoint = {
    company: 'company',
    image: 'image',
    title: 'title'
  };

  const currentFormOptions = isShowingStoppedList ? stoppedSearchFormOptionsForRecruitment : searchFormOptionsForRecruitment;

  const handleClearEmploymentTypes = () => {
    setTargetEmploymentTypes((prev: string[]) => (prev.length === 0 ? prev : []));
  };

  const handleSelectAllEmploymentTypes = () => {
    const all = currentFormOptions.recruitment_employment_types || [];
    // 全選択済みなら state を変えず、冗長な再検索を防ぐ
    setTargetEmploymentTypes((prev: string[]) => (prev.length === all.length ? prev : [...all]));
  };

  const handleClearOccupations = () => {
    setTargetOccupations((prev: string[]) => (prev.length === 0 ? prev : []));
    setTargetOccupationDetails((prev: string[]) => (prev.length === 0 ? prev : []));
    setOccupationDetailsOccupationIds((prev) => prev.map((o) => ({ ...o, occupation_detail_id: [] })));
  };

  const handleSelectAllOccupations = () => {
    const all = (currentFormOptions.occupations || []).map((o: { id: number }) => String(o.id));
    setTargetOccupations((prev: string[]) => (prev.length === all.length ? prev : all));
  };

  const handleClearLocations = () => {
    setTargetPrefectures((prev: string[]) => (prev.length === 0 ? prev : []));
    setTargetPrefectureDetails((prev: string[]) => (prev.length === 0 ? prev : []));
    setPrefectureDetails({
      '北海道・東北': [],
      関東: [],
      '北陸・甲信越': [],
      東海: [],
      近畿: [],
      '中国・四国': [],
      '九州・沖縄': [],
    });
  };

  const handleSelectAllLocations = () => {
    const all = (currentFormOptions.all_prefectures || []).map((p: { id: number }) => String(p.id));
    setTargetPrefectureDetails((prev: string[]) => (prev.length === all.length ? prev : all));
  };

  // 詳細検索モーダル「勤務地 > エリア」「勤務地 > 都道府県」ビューの「すべてクリア」。
  // エリア選択は checkAllPrefectureDetails 経由で targetPrefectureDetails まで書き込むため、
  // どちらのビューでも勤務地系の state（エリア名・都道府県 id・エリア別内訳）をまとめて空にする。
  const handleClearAreas = () => {
    handleClearLocations();
  };

  const handleClearPrefectureDetails = () => {
    handleClearLocations();
  };

  // 詳細検索モーダル main ビュー / サイドバー下部の「すべてクリア」（全条件リセット）
  const handleClearAll = () => {
    setTargetEmploymentTypes([]);
    setTargetOccupations([]);
    setTargetOccupationDetails([]);
    setTargetPrefectures([]);
    setTargetPrefectureDetails([]);
    setTargetPreferenceConditions([]);
    setTargetWorkingPeriods([]);
    setTargetSalary({ target_salary_type: '', target_salary_min: '', target_salary_max: '' });
    setQ('');
    setOccupationDetailsOccupationIds((prev) => prev.map((o) => ({ ...o, occupation_detail_id: [] })));
    setPrefectureDetails({
      '北海道・東北': [],
      関東: [],
      '北陸・甲信越': [],
      東海: [],
      近畿: [],
      '中国・四国': [],
      '九州・沖縄': [],
    });
  };

  const handleClearPreferenceConditions = () => {
    setTargetPreferenceConditions((prev: string[]) => (prev.length === 0 ? prev : []));
    setTargetWorkingPeriods((prev: string[]) => (prev.length === 0 ? prev : []));
  };

  const handleChangeSalary = (change: SalaryChange) => {
    setTargetSalary((prev) => ({ ...prev, ...change }));
  };

  // サイドバーに表示している一部抽出の条件をすべて選択する
  const handleSelectAllPreferenceConditions = () => {
    const flatConditions = (currentFormOptions.preference_condition_categories || []).flatMap(
      (c: { preference_conditions: { id: number; name: string }[] }) => c.preference_conditions
    );
    const sidebarIds = SIDEBAR_PREFERENCE_CONDITION_NAMES.flatMap((name) => {
      const condition = flatConditions.find((pc: { name: string }) => pc.name === name);
      return condition ? [String(condition.id)] : [];
    });
    setTargetPreferenceConditions(sidebarIds);
    if ((currentFormOptions.working_period_ids || []).includes(Number(FULL_TIME_WORKING_PERIOD_ID))) {
      setTargetWorkingPeriods([FULL_TIME_WORKING_PERIOD_ID]);
    }
  };

  return (
    <Presentation
      isBrandPage={isBrandPage}
      fromFixed={fromFixed}
      isPage={isPage}
      isPc={isPc}
      chromeEdg={chromeEdg}
      noimage={noimage}
      hoverIcon={hoverIcon}
      isCompany={isCompany}
      isStopped={isStopped}
      dataCategory={dataCategory}
      dataValue={dataValue}
      dataClickPoint={dataClickPoint}
      company={company}
      cancelIcon={cancelIcon}
      isSp={isSp}
      h1TitleState={h1TitleState}
      page={page}
      isReleasedRecruitmentsNone={searchFormOptionsForRecruitment.isReleasedRecruitmentsNone}
      brandName={searchFormOptionsForRecruitment.brandName}
      q={q}
      targetEmploymentTypes={targetEmploymentTypes}
      targetOccupationDetails={targetOccupationDetails}
      targetPrefectureDetails={targetPrefectureDetails}
      targetPreferenceConditions={targetPreferenceConditions}
      targetWorkingPeriods={targetWorkingPeriods}
      preferenceConditionCategories={currentFormOptions.preference_condition_categories}
      workingPeriodIds={currentFormOptions.working_period_ids}
      salaryTypeIds={currentFormOptions.salary_type_ids}
      targetSalary={targetSalary}
      handleChangeSalary={handleChangeSalary}
      loading={loading}
      targetCompanyIds={targetCompanyIds}
      recruitmentEmploymentTypes={currentFormOptions.recruitment_employment_types}
      occupations={currentFormOptions.occupations}
      occupationDetails={currentFormOptions.occupation_details}
      welfares={currentFormOptions.welfares}
      sidePrefectures={currentFormOptions.side_prefectures}
      allPrefectures={currentFormOptions.all_prefectures}
      detailPrefectures={currentFormOptions.detail_prefectures}
      targetOccupations={targetOccupations}
      targetPrefectures={targetPrefectures}
      targetPrefectureNames={targetPrefectureNames}
      occupationDetailsOccupationIds={occupationDetailsOccupationIds}
      prefectureDetails={prefectureDetails}
      spStyle={spStyle}
      toggleStyle={toggleStyle}
      toggleListStyle={toggleListStyle}
      popupStyle={popupStyle}
      modalStyle={modalStyle}
      handleChangeQ={handleChangeQ}
      handleSearch={handleSearch}
      handleOpenSp={handleOpenSp}
      onFirstLoad={handleFirstRecruitmentLoad}
      handlePaginateClick={handlePaginateClick}
      listRef={listRef}
      handleClick={handleClick}
      handleClearEmploymentTypes={handleClearEmploymentTypes}
      handleSelectAllEmploymentTypes={handleSelectAllEmploymentTypes}
      handleClearOccupations={handleClearOccupations}
      handleSelectAllOccupations={handleSelectAllOccupations}
      handleClearLocations={handleClearLocations}
      handleSelectAllLocations={handleSelectAllLocations}
      handleClearAll={handleClearAll}
      handleClearAreas={handleClearAreas}
      handleClearPrefectureDetails={handleClearPrefectureDetails}
      handleClearPreferenceConditions={handleClearPreferenceConditions}
      handleSelectAllPreferenceConditions={handleSelectAllPreferenceConditions}
      handlePopup={handlePopup}
      handleModal={handleModal}
      closePopup={closePopup}
      handleFetchOccupationDetails={handleFetchOccupationDetails}
      handleFetchPrefectureDetails={handleFetchPrefectureDetails}
      checkAllOccupationDetails={checkAllOccupationDetails}
      checkAllPrefectureDetails={checkAllPrefectureDetails}
      openList={openList}
      isShowingStoppedList={isShowingStoppedList}
      handleToggleStoppedList={handleToggleStoppedList}
      hasAnyRecruitments={hasAnyRecruitments}
      hasStoppedRecruitments={hasStoppedRecruitments}
      isShowAttentionPeople={isShowAttentionPeople}
      releasedRecruitmentIds={releasedRecruitmentIds}
      stoppedRecruitmentIds={stoppedRecruitmentIds}
    />
  );
};
